import Routes from './routes';
import React from 'react';

const App = () => <Routes/>;
localStorage.setItem('urlParsed',`https://cotton-api.agsurveyors.com/`)
export default App;